export { default as wrapRootElement } from 'context/GlobalProvider';
